import { RegisterComponent } from '@feng3d/ecs';
import { AmbientLight } from '../../thirdparty/three/imports';
import { Light3D } from './Light3D';

declare module '@feng3d/ecs'
{
    interface ComponentMap { AmbientLight3D: AmbientLight3D; }
}

/**
 * 3D环境光，包装`three`中`AmbientLight`
 */
@RegisterComponent({ name: 'AmbientLight3D' })
export class AmbientLight3D extends Light3D
{
    _light: AmbientLight = new AmbientLight();
}
